import './styles/main.scss';
import { lazy, Suspense } from 'react';
import { HashRouter, Route, Routes } from 'react-router-dom';
import ScanQR from "./pages/scanQR";
import Balance from "./pages/balance";
import Blocks from "./pages/blocks";

// Портал сотрудников грузится отдельным файлом — продавцы в Mini App его не скачивают
const PortalApp = lazy(() => import('./portal/PortalApp'));

function App() {
    return (
        <HashRouter>
            <Routes>
                <Route path="/scan_qr" element={<ScanQR />} />
                <Route path="/balance" element={<Balance />} />
                <Route path="/blocks" element={<Blocks />} />
                <Route path="/admin/*" element={
                    <Suspense fallback={<div style={{ padding: 24 }}>Загрузка портала…</div>}>
                        <PortalApp />
                    </Suspense>
                } />
                <Route path="/" element={<ScanQR />} />
                <Route path="*" element={<ScanQR />} />
            </Routes>
        </HashRouter>
    );
}

export default App;
